import { CSSProperties, forwardRef } from "react";
import StoreInput from "../../StoreComponents/StoreInput";
import { TextFieldProps } from "@mui/material";

export const CheckoutInput = forwardRef<
  HTMLDivElement,
  TextFieldProps & {
    label?: string;
    inputStyle?: CSSProperties;
  }
>((props, ref) => {
  return (
    <StoreInput
      inputStyle={{
        width: "100%",
        maxWidth: "100%",
        minWidth: 200,
        ...props.inputStyle,
      }}
      {...props}
      textFieldStyle={{ maxWidth: "100%" }}
      ref={ref}
    />
  );
});

CheckoutInput.displayName = "CheckoutInput";
